import { render, staticRenderFns } from "./ChangeAssetLocation.vue?vue&type=template&id=246e2c12"
import script from "./ChangeAssetLocation.vue?vue&type=script&lang=js"
export * from "./ChangeAssetLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports